import type { components } from "@/api/schema";

type Marketplace = components["parameters"]["Marketplace"];

export interface RowRef {
  sku: string;
  marketplace: Marketplace;
}

/**
 * Splits a table row key "<sku>-<marketplace>" back into its parts.
 * SKUs can themselves contain hyphens (e.g. "0011031_P1x12"), so the split
 * is on the LAST hyphen. A key with no usable separator falls back to an
 * empty marketplace rather than throwing.
 */
export function parseRowKey(key: string): RowRef {
  const idx = key.lastIndexOf("-");
  if (idx <= 0) return { sku: key, marketplace: "" as Marketplace };
  return { sku: key.substring(0, idx), marketplace: key.substring(idx + 1) as Marketplace };
}
